import Tabby from "tabbyjs";
import { setupRellax } from "./common";

const setupTabs = () => {
    if (document.querySelectorAll('[data-tabs]').length > 0) {
        new Tabby('[data-tabs]');
    }
};

document.addEventListener('DOMContentLoaded', () => {
    setupRellax();
    setupTabs();
});
